'use client';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useTranslation } from 'react-i18next';

export function DatenqualitaetContent() {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 gap-5 lg:gap-7.5">
      <Card>
        <CardHeader>
          <CardTitle as="h1">{t('pages.region.dataQuality.contentTitle')}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <p className="text-sm text-foreground">
              {t('pages.region.dataQuality.contentText')}
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}